
/* =============================================================================
DB:       Realtime DB
PURPOSE:  Stores commitment sessions
============================================================================= */

export default {

  create(_, data, BACKEND) {
    return {}
  },

  fields: {
    // validate_bolt_type: 'CommitmentDailySettingsItem[]'
  }
};
